// this is an autogenerated file from App/Account/NewPatient/Content/Panes/Form/Fields/AssignedDoctor/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_NewPatient_Content_Panes_Form_Fields_AssignedDoctor($current_location_id: uuid!) {
  vaxiom_persons(
    where: {
      employment_contracts: {
        employment_end_date: { _is_null: true }
        organization_id: { _is_null: false }
        employee_resources: {
          invalid: { _eq: false }
          resource: {
            organization: { _id: { _eq: $current_location_id } }
            resource_type: { is_provider: { _eq: true } }
          }
        }
      }
    }
  ) {
    id
    first_name
    last_name
    employment_contracts {
      id
      # Make sure that we fetch only one employee_resource for each employment_contracts
      employee_resources(
        where: {
          invalid: { _eq: false }
          resource: {
            organization: { _id: { _eq: $current_location_id } }
            resource_type: { is_provider: { _eq: true } }
          }
        }
      ) {
        id
      }
    }
  }
}

`